"use client";

import { motion } from "framer-motion";

export default function DigitalFrontierSection() {
    return (
        <section className="bg-white text-black min-h-[auto] lg:min-h-[90vh] flex items-center overflow-hidden relative pt-20 lg:pt-32 pb-4 lg:pb-0" data-header-theme="dark">
            <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center h-full">

                {/* Left - Hero Image */}
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                    className="relative h-[50vh] lg:h-[80vh] w-full"
                >
                    {/* Gradient mask to fade image at bottom */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white z-10"></div>

                    <img
                        src="/images/ar-vr/vr-headset-white.png"
                        alt="The Digital Frontier"
                        className="w-full h-full object-contain object-center lg:object-left"
                    />
                </motion.div>

                {/* Right - Content */}
                <div className="flex flex-col justify-center h-full pb-2 lg:pb-20 pt-10 lg:pt-0 lg:pl-12">
                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="text-gray-500 text-[1.125rem] tracking-[0.3em] font-medium uppercase mb-6"
                    >
                        Extended Reality
                    </motion.p>

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                        className="text-[3rem] font-light tracking-tight leading-none mb-12 text-black"
                    >
                        THE DIGITAL <br />
                        <span className="font-normal">FRONTIER</span>
                    </motion.h2>



                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.8 }}
                        className="text-gray-600 text-[1.125rem] leading-relaxed max-w-md mb-12"
                    >
                        We design and build cutting-edge Extended Reality (XR) experiences. By seamlessly blending physical and digital worlds, we help brands and enterprises unlock new immersive possibilities and redefine human-computer interaction.
                    </motion.p>
                </div>

            </div>
        </section>
    );
}
